import { render, staticRenderFns } from "./BuildingFormEdit.vue?vue&type=template&id=abe683e4&"
import script from "./BuildingFormEdit.vue?vue&type=script&lang=js&"
export * from "./BuildingFormEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports